(function () {
  var config = window.edulandPixelConfig || {};
  if (config.enabled === false || !config.pixelId) return;

  var PIXEL_SRC = 'https://connect.facebook.net/en_US/fbevents.js';
  var readyQueue = [];
  var fbqReady = false;
  var ownsFbq = false;
  var sentKeys = {};

  function marketingAllowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (privacy && typeof privacy.marketingAllowed === 'function') {
        return privacy.marketingAllowed();
      }
    } catch (error) {}
    return true;
  }

  function eventId() {
    return 'edl_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 10);
  }

  function money(value) {
    var number = Number(value);
    if (!isFinite(number)) return 0;
    return Math.round(number) / 100;
  }

  function productPayload(extra) {
    var product = config.product || {};
    var payload = {
      content_type: 'product',
      content_ids: product.variantId ? [String(product.variantId)] : [],
      content_name: product.title || '',
      content_category: product.type || '',
      value: money(product.price),
      currency: config.currency || 'TRY',
      num_items: 1
    };
    if (extra) {
      for (var key in extra) {
        if (Object.prototype.hasOwnProperty.call(extra, key) && extra[key] != null) {
          payload[key] = extra[key];
        }
      }
    }
    return payload;
  }

  function publishShopify(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, data || {});
      }
    } catch (error) {}
  }

  function once(key, ms) {
    var now = Date.now();
    if (sentKeys[key] && now - sentKeys[key] < (ms || 1200)) return false;
    sentKeys[key] = now;
    return true;
  }

  function withFbq(callback) {
    if (!marketingAllowed()) return;
    if (fbqReady && window.fbq) {
      callback(window.fbq);
      return;
    }
    readyQueue.push(callback);
  }

  function flushQueue() {
    fbqReady = true;
    var queue = readyQueue.slice();
    readyQueue = [];
    queue.forEach(function (callback) {
      try {
        callback(window.fbq);
      } catch (error) {}
    });
  }

  function loadFbq() {
    if (window.fbq) {
      ownsFbq = false;
      flushQueue();
      return;
    }

    var waited = 0;
    var timer = setInterval(function () {
      waited += 100;
      if (window.fbq) {
        clearInterval(timer);
        ownsFbq = false;
        flushQueue();
        return;
      }
      if (waited >= 2500) {
        clearInterval(timer);
        if (!window.fbq) {
          !function (f, b, e, v, n, t, s) {
            if (f.fbq) return;
            n = f.fbq = function () {
              n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
            };
            if (!f._fbq) f._fbq = n;
            n.push = n;
            n.loaded = true;
            n.version = '2.0';
            n.queue = [];
            t = b.createElement(e);
            t.async = true;
            t.src = v;
            s = b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t, s);
          }(window, document, 'script', PIXEL_SRC);
          window.fbq('init', config.pixelId);
          ownsFbq = true;
        }
        flushQueue();
      }
    }, 100);
  }

  function trackCustom(name, data) {
    var payload = data || {};
    publishShopify(name, payload);
    withFbq(function (fbq) {
      fbq('trackCustom', name, payload, { eventID: eventId() });
    });
  }

  function trackStandard(name, data) {
    var payload = data || {};
    publishShopify('eduland_' + name, payload);
    withFbq(function (fbq) {
      fbq('track', name, payload, { eventID: eventId() });
    });
  }

  function qtyFrom(context) {
    var root = context || document;
    var input = root.querySelector('input[name="quantity"]');
    var value = input ? parseInt(input.value, 10) : 1;
    return isFinite(value) && value > 0 ? value : 1;
  }

  function variantFrom(form) {
    if (!form) return config.product && config.product.variantId;
    var input = form.querySelector('input[name="id"]:checked, select[name="id"]') || form.querySelector('input[name="id"]');
    return input && input.value ? input.value : config.product && config.product.variantId;
  }

  function onBuyNow(button) {
    if (!once('HemenSatinAl')) return;
    var form = button.closest('form');
    var qty = qtyFrom(form) || qtyFrom(document);
    var payload = productPayload({
      content_ids: [String(variantFrom(form) || '')].filter(Boolean),
      num_items: qty,
      value: money((config.product && config.product.price) * qty),
      source: 'hemen_satin_alin'
    });
    trackCustom('HemenSatinAl', payload);
    trackStandard('InitiateCheckout', payload);
  }

  function onAddToCart(button) {
    if (button.classList.contains('eduland-buy-now')) return;
    if (!once('SepeteEkle')) return;
    var form = button.closest('form');
    var qty = qtyFrom(form) || qtyFrom(document);
    var payload = productPayload({
      content_ids: [String(variantFrom(form) || '')].filter(Boolean),
      num_items: qty,
      value: money((config.product && config.product.price) * qty),
      source: 'sepete_ekle'
    });
    trackCustom('SepeteEkle', payload);
    if (ownsFbq) trackStandard('AddToCart', payload);
  }

  function onCheckout(button) {
    if (!once('OdemeyeGec', 2000)) return;
    var fatura = document.querySelector('input[name="attributes[Fatura Tipi]"]:checked');
    var payload = {
      currency: config.currency || 'TRY',
      value: money(config.cart && config.cart.total),
      num_items: (config.cart && config.cart.itemCount) || 0,
      content_name: fatura ? fatura.value : 'Bireysel',
      source: 'odemeye_gec'
    };
    trackCustom('OdemeyeGec', payload);
    trackStandard('InitiateCheckout', payload);
  }

  function bind() {
    document.addEventListener('click', function (event) {
      var buyNow = event.target.closest('.eduland-buy-now');
      if (buyNow) {
        onBuyNow(buyNow);
        return;
      }

      var add = event.target.closest('button[name="add"], .button--product-action');
      if (add) {
        onAddToCart(add);
        return;
      }

      var kampanya = event.target.closest('#eduland-kamp-join');
      if (kampanya) {
        if (!once('Kampanya4Al3Ode')) return;
        trackCustom('Kampanya4Al3Ode', productPayload({ content_name: '4 Al 3 Öde' }));
        return;
      }

      var category = event.target.closest('.collection-card_link');
      if (category) {
        if (!once('KategoriTiklama:' + (category.href || ''), 800)) return;
        trackCustom('KategoriTiklama', {
          content_name: (category.textContent || '').replace(/\s+/g, ' ').trim(),
          content_type: 'product_group',
          content_ids: category.href ? [category.href] : []
        });
        return;
      }

      var banner = event.target.closest('.banner-slideshow .buttons-wrap a, .banner-slideshow .buttons-wrap button');
      if (banner) {
        if (!once('BannerKesfet')) return;
        trackCustom('BannerKesfet', {
          content_name: (banner.textContent || '').replace(/\s+/g, ' ').trim(),
          source: 'anasayfa_banner'
        });
        return;
      }

      var checkout = event.target.closest('button[name="checkout"], .button-top-checkout');
      if (checkout) {
        onCheckout(checkout);
        return;
      }

      var cartTrigger = event.target.closest('[data-modal-ref="modal-cart-drawer"], [data-modal-ref*="modal-cart-drawer"]');
      if (cartTrigger) {
        if (!once('SepetGoruntuleme', 2000)) return;
        var cartPayload = {
          currency: config.currency || 'TRY',
          value: money(config.cart && config.cart.total),
          num_items: (config.cart && config.cart.itemCount) || 0,
          source: 'sepet_cekmece'
        };
        trackCustom('SepetGoruntuleme', cartPayload);
        trackStandard('ViewCart', cartPayload);
      }
    });

    document.addEventListener('change', function (event) {
      if (!event.target.matches('input[name="attributes[Fatura Tipi]"]')) return;
      if (!once('FaturaTipi:' + event.target.value, 400)) return;
      trackCustom('FaturaTipi', {
        content_name: event.target.value,
        source: 'fatura_secimi'
      });
    });
  }

  function pageEvents() {
    if (config.page === 'product' && config.product) {
      trackCustom('UrunGoruntuleme', productPayload({ source: 'urun_sayfasi' }));
    }

    if (config.page === 'collection' && config.collection) {
      trackCustom('KategoriGoruntuleme', {
        content_type: 'product_group',
        content_name: config.collection.title || '',
        content_ids: config.collection.id ? [String(config.collection.id)] : []
      });
    }

    if (config.page === 'cart') {
      var cartPayload = {
        currency: config.currency || 'TRY',
        value: money(config.cart && config.cart.total),
        num_items: (config.cart && config.cart.itemCount) || 0,
        source: 'sepet_sayfasi'
      };
      trackCustom('SepetGoruntuleme', cartPayload);
      trackStandard('ViewCart', cartPayload);
    }

    if (config.page === 'search' && config.search) {
      trackStandard('Search', { search_string: config.search });
      trackCustom('Arama', { search_string: config.search });
    }

    if (document.querySelector('.eduland-free-ship') && !document.querySelector('.eduland-free-ship[hidden]')) {
      trackCustom('UcretsizKargoGoruntuleme', {
        content_name: 'Kargo bu saate özel ücretsiz',
        source: 'kargo_sayaci'
      });
    }
  }

  window.edulandPixel = {
    track: trackCustom,
    trackStandard: trackStandard
  };

  loadFbq();
  bind();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pageEvents);
  } else {
    pageEvents();
  }
})();
